import React, { FunctionComponent, useContext } from "react";
import { ensure, getById } from "sprint-common-web";

import { TvSeriesDashboardContext } from "../../../TvSeriesDashboardProvider";
import { EpisodeDetails } from "../../../TvSeriesDetails";
import { TvSeriesContext } from "../../context/TvSeriesContext";
import { UpdatedSeasonData } from "../info/edit-season-form/EditSeasonForm";
import { SeasonPageContext } from "./SeasonPageContext";

type SeasonPageProviderProps = React.PropsWithChildren<unknown>;

export const SeasonPageProvider: FunctionComponent<SeasonPageProviderProps> = (props: SeasonPageProviderProps) => {
    const { children } = props;

    const { addEpisode: addEpisodeToTvSeries, tvSeries, updateSeason: updateSeasonInTvSeries } = useContext(
        TvSeriesContext
    );
    const { selectedSeason, selectCurrentSeason } = useContext(TvSeriesDashboardContext);

    ensure(tvSeries);
    ensure(selectedSeason);

    const season = getById(tvSeries.seasons, selectedSeason.id);

    const addEpisode = (newEpisode: EpisodeDetails) => {
        addEpisodeToTvSeries(selectedSeason.id, { ...newEpisode, isModified: true });
    };

    const updateSeason = (updatedSeasonData: UpdatedSeasonData) => {
        updateSeasonInTvSeries(updatedSeasonData.seasonId, updatedSeasonData.name, updatedSeasonData.number);
        selectCurrentSeason(updatedSeasonData.seasonId, updatedSeasonData.name);
    };

    return (
        <SeasonPageContext.Provider
            value={{
                selectedTvSeries: tvSeries,
                selectedSeason: season,
                addEpisode,
                updateSeason
            }}
        >
            {children}
        </SeasonPageContext.Provider>
    );
};
